"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isoUnicode = _interopRequireDefault(require("./isoUnicode"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var CURRENCY_CODES = [{
  value: 'AUD',
  flag: _isoUnicode["default"].AU,
  label: 'Australia Dollar',
  country: 'Australia',
  symbol: 'A$',
  iso2: 'AU'
}, {
  value: 'BRL',
  flag: _isoUnicode["default"].BR,
  label: 'Brazil Real',
  country: 'Brazil',
  symbol: 'R$',
  iso2: 'BR'
}, {
  value: 'CAD',
  flag: _isoUnicode["default"].CA,
  label: 'Canada Dollar',
  country: 'Canada',
  symbol: 'C$',
  iso2: 'CA'
}, {
  value: 'CHF',
  flag: _isoUnicode["default"].CH,
  label: 'Switzerland Franc',
  country: 'Switzerland',
  symbol: 'Fr',
  iso2: 'CH'
}, {
  value: 'CNY',
  flag: _isoUnicode["default"].CN,
  label: 'China Yuan Renminbi',
  country: 'China',
  symbol: '元',
  iso2: 'CN'
}, {
  value: 'CZK',
  flag: _isoUnicode["default"].CZ,
  label: 'Czech Republic Koruna',
  country: 'Czech Republic',
  symbol: 'Kč',
  iso2: 'CZ'
}, {
  value: 'DKK',
  flag: _isoUnicode["default"].DK,
  label: 'Denmark Krone',
  country: 'Denmark',
  symbol: 'kr',
  iso2: 'DK'
}, {
  value: 'EUR',
  flag: _isoUnicode["default"].EU,
  label: 'Euro',
  country: 'European Union',
  symbol: '€',
  iso2: 'EU'
}, {
  value: 'GBP',
  flag: _isoUnicode["default"].GB,
  label: 'Great Britain Pound',
  country: 'Great Britain',
  symbol: '£',
  iso2: 'GB'
}, {
  value: 'HKD',
  flag: _isoUnicode["default"].HK,
  label: 'Hong Kong Dollar',
  country: 'Hong Kong',
  symbol: 'HK$',
  iso2: 'HK'
}, {
  value: 'HRK',
  flag: _isoUnicode["default"].HR,
  label: 'Croatia Kuna',
  country: 'Croatia',
  symbol: 'kn',
  iso2: 'HR'
}, {
  value: 'INR',
  flag: _isoUnicode["default"].IN,
  label: 'India Rupee',
  country: 'India',
  symbol: 'INR',
  iso2: 'IN'
}, {
  value: 'JMD',
  flag: _isoUnicode["default"].JM,
  label: 'Jamaica Dollar',
  country: 'Jamaica',
  symbol: 'J$',
  iso2: 'JM'
}, {
  value: 'JPY',
  flag: _isoUnicode["default"].JP,
  label: 'Japan Yen',
  country: 'Japan',
  symbol: '¥',
  iso2: 'JP'
}, {
  value: 'KRW',
  flag: _isoUnicode["default"].KR,
  label: 'Korea (South) Won',
  country: 'South Korea',
  symbol: '₩',
  iso2: 'KR'
}, {
  value: 'MYR',
  flag: _isoUnicode["default"].MY,
  label: 'Malaysia Ringgit',
  country: 'Malaysia',
  symbol: 'RM',
  iso2: 'MY'
}, {
  value: 'NOK',
  flag: _isoUnicode["default"].NO,
  label: 'Norway Krone',
  country: 'Norway',
  symbol: 'kr',
  iso2: 'NO'
}, {
  value: 'NZD',
  flag: _isoUnicode["default"].NZ,
  label: 'New Zealand Dollar',
  country: 'New Zealand',
  symbol: 'NZ$',
  iso2: 'NZ'
}, {
  value: 'PHP',
  flag: _isoUnicode["default"].PH,
  label: 'Philippines Peso',
  country: 'Phillippines',
  symbol: '₱',
  iso2: 'PH'
}, {
  value: 'PLN',
  flag: _isoUnicode["default"].PL,
  label: 'Poland Zloty',
  country: 'Poland',
  symbol: 'zł',
  iso2: 'PL'
}, {
  value: 'SEK',
  flag: _isoUnicode["default"].SE,
  label: 'Sweden Krona',
  country: 'Sweden',
  symbol: 'kr',
  iso2: 'SE'
}, {
  value: 'SGD',
  flag: _isoUnicode["default"].SG,
  label: 'Singapore Dollar',
  country: 'Singapore',
  symbol: 'S$',
  iso2: 'SG'
}, {
  value: 'THB',
  flag: _isoUnicode["default"].TH,
  label: 'Thailand Baht',
  country: 'Thailand',
  symbol: '฿',
  iso2: 'TH'
}, {
  value: 'TND',
  flag: _isoUnicode["default"].TN,
  label: 'Tunisia Dinar',
  country: 'Tunisia',
  symbol: 'DT',
  iso2: 'TN'
}, {
  value: 'TRY',
  flag: _isoUnicode["default"].TR,
  label: 'Turkey Lira',
  country: 'Turkey',
  symbol: 'TL',
  iso2: 'TR'
}, {
  value: 'TWD',
  flag: _isoUnicode["default"].TW,
  label: 'Taiwan New Dollar',
  country: 'Taiwan',
  symbol: 'NT$',
  iso2: 'TW'
}, {
  value: 'USD',
  flag: _isoUnicode["default"].US,
  label: 'United States Dollar',
  country: 'America',
  symbol: '$',
  iso2: 'US'
}, {
  value: 'ZAR',
  flag: _isoUnicode["default"].ZA,
  label: 'South Africa Rand',
  country: 'South Africa',
  symbol: 'R',
  iso2: 'ZA'
}];
var _default = CURRENCY_CODES;
exports["default"] = _default;